import dayjs from "dayjs";

export function FormatDate(date) {
  if (!date) return "-";

  // If the object has a $d property (from serialized dayjs), use it
  const parsedDate =
    typeof date === "object" && date.$d ? dayjs(date.$d) : dayjs(date);

  if (!parsedDate.isValid()) {
    return "-";
  }

  return parsedDate.format("DD/MM/YYYY");
}

// Format to YY-MM-DD
export function FormatDateShort(date) {
  if (!date) return "-";

  const parsedDate =
    typeof date === "object" && date.$d ? dayjs(date.$d) : dayjs(date);

  if (!parsedDate.isValid()) {
    return "-";
  }

  return parsedDate.format("DD/MM/YYYY");
}

export function FormatDateShort_DD(date) {
  if (!date) return "-";

  const parsedDate =
    typeof date === "object" && date.$d ? dayjs(date.$d) : dayjs(date);

  if (!parsedDate.isValid()) {
    return "-";
  }

  return parsedDate.format("DD/MM/YYYY");
}

// Format to YYYYMM
export function FormatDateYYYYMM(date) {
  if (!date) return "-";

  const parsedDate =
    typeof date === "object" && date.$d ? dayjs(date.$d) : dayjs(date);

  if (!parsedDate.isValid()) {
    return "-";
  }

  return parsedDate.format("YYYYMM");
}
